<script setup lang="ts" name="FormWizardVertical">
import type { VNode } from 'vue';

import FormWizardVerticalHeader from '~/components/FormWizardVerticalHeader.vue';

import type { IStepperStep } from '~/types';

defineProps<{
  steps: IStepperStep[];
  content?: VNode[];
  onSubmit: () => void;
}>();
</script>

<template>
  <form
    class="overflow-hidden rounded bg-white shadow"
    @submit.prevent="onSubmit"
  >
    <div v-for="(step, index) in content" :key="index">
      <FormWizardVerticalHeader
        :step="index + 1"
        :title="steps?.[index].title"
        :disabled="steps?.[index].disabled"
      />

      <div class="border-y border-charcoal-2" :data-testid="`step-${index}`">
        <component :is="step" />
      </div>
    </div>

    <slot name="footer" />
  </form>
</template>
